import isGqlPpStep, { validGqlPpSteps } from './isGqlPpStep';

export { validGqlPpSteps };

export default isGqlPpStep;
